import React, { useEffect, useState, useContext, createContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { UserContext } from '../App';
import MainLayoutWrapper from './MainLayoutWrapper';
import { getLoginToken } from './../helpers/UserHelper';

export const VsPedagogiekContext = createContext(null);

function VsPedagogiekLayoutWrapper({ settings }) {
    const userContext = useContext(UserContext);
    const location = useLocation();

    const [vsPedagogiekTopics, setVsPedagogiekTopics] = useState([]);

    useEffect(() => {
        if (getLoginToken() === null || userContext.fetchHeaders === null || vsPedagogiekTopics.length > 0) return;

        try {
            fetch(settings.apiBaseUrl + 'vs-pedagogiek/general', {
                method: 'POST',
                headers: userContext.fetchHeaders,
            })
                .then(result => result.json())
                .then(response => {
                    if (!response.success) return;
                    setVsPedagogiekTopics(response.vs_pedagogiek.topics);
                });
        } catch (error) {
            console.error(error);
        }
    }, [userContext.fetchHeaders, settings.apiBaseUrl, location.pathname, vsPedagogiekTopics.length]);

    const getTopic = function(topicSlug) {
        return vsPedagogiekTopics.find(topic => topic.slug === topicSlug) || null;
    };

    return (
        <VsPedagogiekContext.Provider value={{
            topics: vsPedagogiekTopics,
            getTopic
        }}>
            <MainLayoutWrapper settings={settings}>
                <Outlet key={location.pathname} />
            </MainLayoutWrapper>
        </VsPedagogiekContext.Provider>
    );
}

export default VsPedagogiekLayoutWrapper;